import { CompositeDecorator } from "draft-js";

import styles from "./textEditor.module.css";

export const findLinkEntities = (contentBlock, callback, contentState) => {
    contentBlock.findEntityRanges((character) => {
        const entityKey = character.getEntity();
        if (!entityKey) return false;
        return contentState.getEntity(entityKey).getType() === "LINK";
    }, callback);
};

export const LinkEntity = (props) => {
    const { url } = props.contentState.getEntity(props.entityKey).getData();

    return (
        <a
            href={url}
            className={styles.link}
            style={{ color: "var(--app-accent-color)", textDecorationColor: "var(--app-accent-color)" }}
            target="_blank"
            rel="noopener noreferrer"
            onMouseDown={(e) => e.stopPropagation()}
        >
            {props.children}
        </a>
    );
};

export const createLinkDecorator = () => new CompositeDecorator([
    {
        strategy: findLinkEntities,
        component: LinkEntity,
    },
]);
